module.exports = __webpack_public_path__ + "6c4a0dbc/img/pdf-icon.79f04a36.svg";